<template>
  <div class="poster">
    <el-divider content-position="left">海报管理</el-divider>
    <el-row>
      <el-button type="primary" size="mini" @click="handleAddOpen">创建海报</el-button>
    </el-row>
    <el-row>
      <el-col
        :span="4"
        v-for="(o, index) in poster"
        :key="index"
        :offset="index % 5 === 0 ? 0 : 1"
      >
        <el-card :body-style="{ padding: '0px' }">
          <div class="dribbble-img">
            <img :src="o.poster_cover" class="image" />
          </div>
          <div style="padding: 14px">
            <el-tooltip :content="o.poster_title" placement="top">
              <span class="text-over">{{ o.poster_title }}</span>
            </el-tooltip>
            <div class="bottom clearfix">
              <time class="time" @click="downloadHistory(o.id)"
                >下载：{{ o.download_times }}</time
              >
              <el-button type="text" class="button m-del" @click="handleDel(o.id, index)"
                >删除</el-button
              >
              <el-button type="text" class="button" @click="handleEdit(index, o)"
                >编辑</el-button
              >
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="pageOption.total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="pageOption.pageSize"
        background
      >
      </el-pagination>
    </div>
    <el-dialog
      title="创建海报"
      width="40%"
      :visible.sync="visible"
      @closed="handleAddClosed"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/poster/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handlePosterSuccess"
        :before-upload="beforePosterUpload"
      >
        <img v-if="addCoverUrl" :src="addCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-form :model="addForm" status-icon :rules="rules" ref="addForm">
        <el-form-item prop="poster_title" label="标题" :label-width="formLabelWidth">
          <el-input v-model="addForm.poster_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="category_id" label="分类" :label-width="formLabelWidth">
          <el-select
            v-model="addForm.category_id"
            filterable
            clearable
            placeholder="请选择海报分类"
          >
            <el-option
              v-for="item in cate"
              :key="item.id"
              :label="item.category_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="poster_desc" label="简述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model="addForm.poster_desc"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleAdd('addForm')"
          >添 加</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑海报"
      width="40%"
      :visible.sync="editVisible"
      @closed="handleEditClosed"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/poster/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleEditPosterSuccess"
        :before-upload="beforePosterUpload"
      >
        <img v-if="editCoverUrl" :src="editCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-form :model="editForm" status-icon :rules="rules" ref="editForm">
        <el-form-item prop="poster_title" label="标题" :label-width="formLabelWidth">
          <el-input v-model="editForm.poster_title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="category_id" label="分类" :label-width="formLabelWidth">
          <el-select
            v-model="editForm.category_id"
            filterable
            clearable
            placeholder="请选择海报分类"
          >
            <el-option
              v-for="item in cate"
              :key="item.id"
              :label="item.category_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="poster_desc" label="简述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model="editForm.poster_desc"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="handleSave('editForm')"
          >保 存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="下载记录" width="50%" :visible.sync="historyVisible">
      <el-row>
        <el-col
          :span="2"
          v-for="(item, index) in frequency"
          :key="index"
          :offset="index % 8 === 0 ? 0 : 1"
        >
          <div class="demo-basic--circle">
            <el-tooltip :content="item.created_at" placement="top">
              <div class="block">
                <el-avatar
                  :size="40"
                  :src="avatarHost + item.admin_user.buphoto"
                ></el-avatar>
              </div>
            </el-tooltip>
            <el-tooltip :content="item.admin_user.username" placement="top">
              <p class="avatar-name">{{ item.admin_user.username }}</p>
            </el-tooltip>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Poster",
  data() {
    return {
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      poster: [],
      cate: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条数
      },
      formLabelWidth: "1.6rem",
      visible: false,
      addCoverUrl: "",
      addForm: {
        category_id: null,
        poster_title: "",
        poster_cover: "",
        poster_desc: "",
      },
      editVisible: false,
      editCoverUrl: "",
      editForm: {
        id: null,
        category_id: null,
        poster_title: "",
        poster_cover: "",
        poster_desc: "",
        arrIndex: null,
      },
      rules: {
        category_id: [
          {
            required: true,
            message: "请选择海报分类",
            trigger: "blur",
          },
        ],
        poster_title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur",
          },
        ],
        poster_desc: [
          {
            required: true,
            message: "简述不能为空",
            trigger: "blur",
          },
        ],
      },
      historyVisible: false,
      frequency: [],
    };
  },
  computed: {
    // pageData: {
    //   get: function () {
    //     return this.poster.slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
    //   }
    // },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    avatarHost: {
      get: function () {
        return process.env.NODE_ENV === "development"
          ? "http://www.qyh.com/uploads/adminuser/"
          : "https://www.qiyehuo.com/uploads/adminuser/";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getPosters() {
      this.$axios
        .get("/api/admin/posters", {
          params: {
            page: this.pageOption.currentPage,
            perpage: this.pageOption.pageSize,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.cate = data.cate;
            this.poster = data.data.data;
            this.pageOption.total = data.data.total;
          }
        });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPosters();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPosters();
    },
    downloadHistory(id) {
      this.$axios.get("/api/admin/poster/frequency/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.frequency = data.data;
        }
      });
      this.historyVisible = true;
    },
    handleAddOpen() {
      this.visible = true;
    },
    handleAddClosed() {
      this.visible = false;
      this.$refs["addForm"].resetFields();
      this.addForm.poster_cover = "";
      this.addCoverUrl = "";
    },
    handleAdd(formName) {
      if (!this.addForm.poster_cover) {
        this.$message.error("请上传海报封面");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/api/admin/posters", this.addForm).then((res) => {
            const { data } = res;
            if (data.code === 0) {
              data.data["download_times"] = 0;
              // this.poster.unshift(data.data)
              // this.pageOption.total = this.poster.length
              this.handleAddClosed();
              this.$message.success("添加成功");
              this.getPosters();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleEdit(index, row) {
      this.editForm.id = row.id;
      this.editForm.category_id = row.category_id;
      this.editForm.poster_title = row.poster_title;
      this.editForm.poster_cover = row.poster_cover;
      this.editForm.poster_desc = row.poster_desc;
      this.editForm.arrIndex = index;
      this.editCoverUrl = row.poster_cover;
      this.editVisible = true;
    },
    handleEditClosed() {
      this.editVisible = false;
      this.editForm.id = null;
      this.editForm.category_id = null;
      this.editForm.poster_title = "";
      this.editForm.poster_cover = "";
      this.editForm.poster_desc = "";
      this.editForm.arrIndex = null;
      this.editCoverUrl = "";
    },
    handleSave(formName) {
      if (!this.editForm.poster_cover) {
        this.$message.error("请上传海报封面");
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post("/api/admin/posters/update", this.editForm).then((res) => {
            const { data } = res;
            if (data.code === 0) {
              // let index = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + this.editForm.arrIndex
              // this.poster[index].category_id = this.editForm.category_id
              // this.poster[index].poster_title = this.editForm.poster_title
              // this.poster[index].poster_cover = this.editForm.poster_cover
              // this.poster[index].poster_desc = this.editForm.poster_desc
              this.$message.success(data.msg);
              this.handleEditClosed();
              this.getPosters();
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleDel(id, index) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.submitDel(id, index);
        })
        .catch(() => {});
    },
    submitDel(id, index) {
      this.$axios.post("/api/admin/posters/destroy", { id }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          // let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index
          // this.poster.splice(idx, 1)
          // this.pageOption.total = this.poster.length
          // if (index === 0) this.prePage()
          this.$message.success(data.msg);
          this.getPosters();
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // prePage () {
    //   if (this.pageOption.currentPage === 1) return
    //   this.pageOption.currentPage = this.pageOption.currentPage - 1
    // },
    beforePosterUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }

      if (!isLt2M) {
        this.$message.error("封面图片大小不能超过 2MB!");
        return false;
      }

      return true;
    },
    handlePosterSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        // this.addForm.poster_cover = this.imgPath + res.data.store_result
        this.addForm.poster_cover = res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEditPosterSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.editForm.poster_cover = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
  mounted() {
    this.getPosters();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.poster >>> .avatar-uploader
  text-align: center
  margin-bottom: .2rem
.poster >>> .avatar-uploader .el-upload
  border: .02rem dashed #d9d9d9
  border-radius: .12rem
  cursor: pointer
  position: relative
  overflow: hidden
.poster >>> .avatar-uploader .el-upload:hover
  border-color: #409eff
.poster >>> .el-upload img
  width: 2.5rem
  height: 3.4rem
.el-row
  margin-bottom: .2rem
.el-select
  width: 100%
.clearfix:before,
.clearfix:after
  display: table
  content: ""
.avatar-uploader-icon
  font-size: .4rem
  color: #8c939d
  width: 2.5rem
  height: 3.4rem
  line-height: 3.4rem
  text-align: center
.el-date-editor.el-input, .el-date-editor.el-input__inner
  width: 100%
.poster
  marginLeft()
  cardStyle()
  .el-col-4,
  .el-col-2
    margin-bottom: .2rem
  .time
    cursor: pointer
    user-select: none
  .demo-basic--circle
    text-align: center
  .avatar-name
    font-size: 12px
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
</style>



// WEBPACK FOOTER //
// src/pages/poster/Poster.vue